import type {EventRule, Language} from '@/types'
import {appSelectors} from '@/store'
import React from 'react'
import {map, toLower} from 'ramda'
import {tokenizeRuleName} from '@/rules-helper'
import {connect} from 'react-redux'

type Props = {
  l: Language,
  raiseChange: (EventRuleChange) => void,
  rule: EventRule,
  tooltip?: Array<string>,
}

const bandValues = [[1, 2, 3, 4], ['A', 'B', 'C', 'D', 'Any']]

const renderInputHole = ({rule, raiseChange, tooltip}) => (holeNumber: string) => {
  const prop = 'param' + holeNumber
  const tooltipText = tooltip && tooltip[parseInt(holeNumber, 10) + 1]

  return (<input
    key={holeNumber}
    type="number"
    value={rule[prop] || ''}
    onChange={(e) => raiseChange({
      ruleCode: rule.ruleCode,
      prop,
      val: e.currentTarget.value,
    })}
    disabled={!rule.isActive}
    title={tooltipText}
  />)
}

const renderBandDropdown = ({rule, raiseChange, tooltip}) => (holeNumber: string, values: Array<any>) => {
  const prop = 'param' + holeNumber
  const tooltipText = tooltip && tooltip[parseInt(holeNumber, 10) + 1]

  return (<select
    key={holeNumber}
    value={rule[prop] || ''}
    onChange={(e) => raiseChange({
      ruleCode: rule.ruleCode,
      prop,
      val: e.currentTarget.value,
    })}
    disabled={!rule.isActive}
    title={tooltipText}
  >tooltip
    {map((val) =>
      <option key={'dropdown' + val} value={val}>{val}</option>,
    values)}
  </select>)
}

const toBoolean = (val) => val && toLower(val) === 'true'

const toggleTrueFalseString = (val) => toBoolean(val) ? 'false' : 'true'

const renderCheckbox = ({rule, raiseChange, tooltip}) => (holeNumber: string) => {
  const prop = 'param' + holeNumber
  return <input
    key={holeNumber}
    type="checkbox"
    onChange={() => raiseChange({
      ruleCode: rule.ruleCode,
      prop,
      val: toggleTrueFalseString(rule[prop]),
    })}
    checked={toBoolean(rule[prop])}
    disabled={!rule.isActive}
    title={tooltip && tooltip[1]}
  />
}

let key = 3948 // Some random pointless key to increment when creating '|' elements
const renderToken = (props) => (token) => {
  const match = token.match(/{(\d)}/)
  if (match) {
    return props.rule.ruleCode === 101
      ? match[1] === '2' ? renderCheckbox(props)(match[1]) : renderBandDropdown(props)(match[1], bandValues[match[1]])
      : (props.rule.ruleCode === 102 && match[1] === '0') ? renderCheckbox(props)(match[1]) : renderInputHole(props)(match[1])
  } else if (token === '|') {
    return <div
      key={++key}
      className="spacer"
    ></div>
  } else {
    return <span key={token}>{props.l(token.trim())}</span>
  }
}

export const ComplexRuleName = (props: Props) => {
  const tokens = tokenizeRuleName(props.rule.name)
  return <div>{map(renderToken(props), tokens)}</div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(ComplexRuleName)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/complex-rule-name.js